import UAParser from 'ua-parser-js';

export const FETCH_OS_DATA = 'FETCH_OS_DATA';
export const FETCH_OS_DATA_SUCCESS = 'FETCH_OS_DATA_SUCCESS';
export const FETCH_OS_DATA_FAILURE = 'FETCH_OS_DATA_FAILURE';

export const fetchOSData = headers => dispatch => {
  dispatch({
    type: FETCH_OS_DATA,
  });
  try {
    const userAgent = headers['user-agent'];
    const parser = new UAParser();
    const ua = userAgent;
    const osName = parser.setUA(ua).getOS().name;
    const osData = { osName };
    dispatch({
      type: FETCH_OS_DATA_SUCCESS,
      osData,
    });
  } catch (error) {
    dispatch({
      type: FETCH_OS_DATA_FAILURE,
      error,
    });
  }
};
